import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useJwt from "@src/auth/jwt/useJwt";

/* =========================
   THUNK
========================= */
export const fetchUserStatus = createAsyncThunk(
  "user/fetchStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await useJwt.userStatus();
      return res.data; 
    } catch (err) {
      const errorStatus =
        err?.onboardingStatus || err?.response?.status;

      return rejectWithValue(errorStatus || null);
    }
  }
);

/* =========================
   SLICE
========================= */
const userSlice = createSlice({
  name: "status",
  initialState: {
    status: null,
    before_credentialing:{},
    loading: false,
    error: null,
  },
  reducers: {
    // optional manual reset if needed
    clearUserStatus: (state) => {
      state.status = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload;
        state.before_credentialing = action.payload
      })
      .addCase(fetchUserStatus.rejected, (state, action) => {
        state.loading = false;
        state.status = action.payload; // fallback status
        state.error = action.payload;
      });
  },
});

export const { clearUserStatus } = userSlice.actions;
export default userSlice.reducer;